import {
	ActionReducerMap,
	combineReducers,
	createFeature,
	createFeatureSelector
} from '@ngrx/store';
import {
	PremiumCheckTokenState,
	PremiumDiscountListState,
	PremiumModulesState
} from './extra.entity';
import {
	myPremium,
	paymentIntent,
	premiumCheckToken,
	premiumCoupon,
	premiumDisconutTypeList,
	premiumModulesList
} from './extra.reducer';
import { MyPremiumState, CouponState, PaymentIntentState } from './extra.model';

export const EXTRA_FEATURE_NAME: string = 'premium';

// Selector for top-level content
export const selectPremiumState = createFeatureSelector<PremiumState>(EXTRA_FEATURE_NAME);

export interface PremiumState {
	premiumModulesList: PremiumModulesState;
	premiumCheckToken: PremiumCheckTokenState;
	myPremium: MyPremiumState;
	premiumDisconutTypeList: PremiumDiscountListState;
	premiumCoupon: CouponState;
	paymentIntent: PaymentIntentState;
}

export const reducers = combineReducers({
	premiumModulesList: premiumModulesList,
	premiumCheckToken: premiumCheckToken,
	myPremium: myPremium,
	premiumDisconutTypeList: premiumDisconutTypeList,
	premiumCoupon: premiumCoupon,
	paymentIntent: paymentIntent
});

export const extraFeature = createFeature({
	name: EXTRA_FEATURE_NAME,
	reducer: reducers
});
